/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Risks_PsychologyInputs */

const en_footer_risks_psychology = /** @type {(inputs: Footer_Risks_PsychologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychology of x-risk`)
};

/**
* | output |
* | --- |
* | "Psychology of x-risk" |
*
* @param {Footer_Risks_PsychologyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_risks_psychology = /** @type {((inputs?: Footer_Risks_PsychologyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Risks_PsychologyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_risks_psychology(inputs)
});